<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Blog Grid" />
            <BlogComp />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'
import BlogComp from '../Blog/BlogComp'
import FooterComp from '../Layouts/FooterComp'

export default {
    name: 'BlogPage',
    components: {
        NavBar,
        PageTitle,
        BlogComp,
        FooterComp,
    }
}
</script>